<template>
  <div class="row job-page">
    <div class="col-12">
      <div class="row pb-5" style="margin-top: 110px">
        <div class="col-12 col-lg-10 mx-auto">
          <div class="bg-white shadow-sm">
            <div class="row">
              <div class="col-10 mx-auto my-5" v-if="opportunity">
                <div class="border-bottom border-light-dark py-4 mb-md-5">
                  <div class="d-flex align-items-center">
                    <h1 class="h0 m-0">
                      <wheelchair-accessibility-icon
                        class="mr-2 text-wl-primary"
                        v-if="opportunity.pcd"
                        v-b-tooltip.hover="'Pessoas com Deficiência (PCD)'"
                      />
                      {{ opportunity.title }}
                    </h1>

                    <Share :url="opportunity.slug" class="ml-3" />
                  </div>

                  <div
                    class="text-muted mt-2 d-flex align-items-center"

                  >
                    <map-marker-icon class="mb-0 mr-1 h4" />

                    <div>
                      <h6 class="font-weight-normal m-0">
                        {{ opportunity.acting_mode }}<span v-if="opportunity.address">, {{ this.$helpers.toTitle(opportunity.address.city) }}
                          {{ opportunity.address.state && " - " + opportunity.address.state.abbr }} <br />
                          <small
                            v-if="opportunity.address.street"
                            class="text-capitalize"
                            >{{ opportunity.address.street.toLowerCase() }}</small
                          >
                          <small v-if="opportunity.address.number"
                            >, {{ opportunity.address.number }}</small
                          >
                          <small
                            v-if="opportunity.address.neighborhood"
                            class="text-capitalize"
                          >
                            -
                            {{
                              opportunity.address.neighborhood.toLowerCase()
                            }}</small
                          >
                        </span>
                      </h6>
                    </div>
                  </div>
                </div>

                <dl class="row no-gutters text-secondary m-0">
                  <dt
                    class="
                      col-12 col-md-3
                      mt-4
                      border-right border-light-dark
                      text-right
                      pr-md-4
                    "
                    v-if="opportunity.responsability"
                  >
                    Responsabilidades
                  </dt>
                  <dd
                    class="col-12 col-md-9 mt-4 pl-md-4"
                    v-if="opportunity.responsability"
                  >
                    <div v-html="opportunity.responsability"></div>
                  </dd>

                  <dt
                    class="
                      col-12 col-md-3
                      mt-4
                      border-right border-light-dark
                      text-right
                      pr-md-4
                    "
                    v-if="opportunity.requirement"
                  >
                    Requisitos
                  </dt>
                  <dd
                    class="col-12 col-md-9 mt-4 pl-md-4"
                    v-if="opportunity.requirement"
                  >
                    <div v-html="opportunity.requirement"></div>
                  </dd>

                  <dt
                    class="
                      col-12 col-md-3
                      mt-4
                      border-right border-light-dark
                      text-right
                      pr-4
                    "
                    v-if="opportunity.work_environment"
                  >
                    Como é o ambiente de trabalho?
                  </dt>
                  <dd
                    class="col-12 col-md-9 mt-4 pl-md-4"
                    v-if="opportunity.work_environment"
                  >
                    <div v-html="opportunity.work_environment"></div>
                  </dd>

                  <dt
                    class="
                      col-12 col-md-3
                      mt-4
                      border-right border-light-dark
                      text-right
                      pr-4
                    "
                    v-if="opportunity.benefits.length"
                  >
                    Benefícios
                  </dt>
                  <dd
                    class="col-12 col-md-9 mt-4 pl-md-4"
                    v-if="opportunity.benefits.length"
                  >
                    <div class="row">
                      <span
                        class="
                          col-12 col-sm-6 col-md-4
                          mb-4
                          d-flex
                          align-items-center
                        "
                        v-for="benefit in opportunity.benefits"
                      >
                        <span
                          class="benefits mr-3 flex-shrink-0"
                          :class="benefit.icon"
                        ></span>
                        {{ benefit.name }}
                      </span>
                    </div>
                  </dd>

                  <dt
                    class="
                      col-12 col-md-3
                      mt-4
                      border-right border-light-dark
                      text-right
                      pr-4
                    "
                    v-if="opportunity.other_benefit"
                  >
                    Observações e/ou<br />Benefícios Adicionais
                  </dt>
                  <dd
                    class="col-12 col-md-9 mt-4 pl-md-4"
                    v-if="opportunity.other_benefit"
                  >
                    <div v-html="opportunity.other_benefit"></div>
                  </dd>

                  <dt
                    class="
                      col-12 col-md-3
                      mt-4
                      border-right border-light-dark
                      text-right
                      pr-4
                    "
                  >
                    Diversidade
                  </dt>
                  <dd class="col-12 col-md-9 mt-4 pl-md-4">
                    <div>
                      <p>
                        Nossos valores nos unem e nossas diferenças nos
                        potencializam como um grupo.
                      </p>
                      <p>
                        Mais do que igualdade, buscamos equidade: Aqui, temos
                        espaço para sermos autênticos, independentemente de
                        gênero, etnia, raça, orientação sexual, credo ou
                        deficiência.
                      </p>
                    </div>
                  </dd>
                </dl>
                <div class="d-flex justify-content-end mt-5 align-items-center">
                  <a
                    href="https://99jobs.com/pages/terms"
                    class="terms btn btn-white text-muted float-left mr-3"
                    target="_blank"
                  >
                    Conheça os termos
                  </a>
                  <router-link
                    @click.native="backTo"
                    to=""
                    class="btn btn-white text-muted float-left mr-3"
                    >Fechar</router-link
                  >

                  <router-link
                    :to="'/vagas/' + opportunity.slug + '/inscricao'"
                    class="btn"
                    :class="[
                      enrolled || opportunity.status_id != 1
                        ? 'text-orange-ml font-weight-bold disabled'
                        : 'btn-wl-primary',
                    ]"
                  >
                    {{
                      enrolled
                        ? "Você já está inscrito"
                        : opportunity.status_id != 1
                        ? "Inscrições Encerradas"
                        : "Inscrever-se!"
                    }}
                  </router-link>
                </div>
              </div>

              <div
                class="col-10 mx-auto my-5 text-center"
                v-if="!opportunity && notFound == true"
              >
                <div class="py-4">
                  <h1 class="m-0">Oportunidade não foi encontrada</h1>

                  <router-link to="/vagas" class="btn btn-wl-primary mt-4"
                    >Confira nossas oportunidades abertas</router-link
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import WheelchairAccessibilityIcon from "vue-material-design-icons/WheelchairAccessibility.vue";
import MapMarkerIcon from "vue-material-design-icons/MapMarker.vue";
import Share from "@/components/jobs/Share.vue";

export default {
  name: "Job",

  data() {
    return {
      opportunity: null,
      notFound: false,
      comingFrom: null,

      pageTitle: "",
    };
  },

  computed: {
    enrolled() {
      const uri = this.opportunity.links.subscription.split("/");
      const name = uri[uri.length - 1];
      const id = name.match(/\d+/)[0];
      return this.$store.state.opportunities.subscriptions.find(
        (subs) => subs.opportunityId == id
      )
        ? true
        : false;
    },
  },

  components: {
    WheelchairAccessibilityIcon,
    MapMarkerIcon,
    Share,
  },

  created() {
    this.getOpportunity();
  },

  beforeDestroy() {
    var robots = document.querySelector('meta[name="robots"]');
    var googlebot = document.querySelector('meta[name="googlebot"]');
    if (robots) robots.parentNode.removeChild(robots);
    if (googlebot) googlebot.parentNode.removeChild(googlebot);
  },

  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.comingFrom = from;
    });
  },

  methods: {
    backTo() {
      if (this.comingFrom.name == null) {
        this.$router.push("/vagas");
      } else {
        this.$router.go(-1);
      }
    },

    getOpportunity() {
      const get = () => {
        this.$store
          .dispatch("opportunities/getOpportunity", this.$route.params.id)
          .then((opportunity) => {
            if (opportunity) {
              this.opportunity = opportunity;
              this.notFound = false;

              this.pageTitle = this.$helpers.toTitle(this.opportunity.title);
              this.$emit("updateHead");

              const googleJobsOpportunity = this.opportunity;
              googleJobsOpportunity.website =
                "https://talentosnapista.99jobs.com/";
              googleJobsOpportunity.logo =
                "https://talentosnapista.99jobs.com/img/talentosnapista-banner.jpg";
              this.$googleJobs(googleJobsOpportunity);

              if (opportunity.hidden == true) {
                var robots = document.createElement("meta");
                var googlebot = document.createElement("meta");
                robots.setAttribute("name", "robots");
                googlebot.setAttribute("name", "googlebot");
                robots.content = "noindex";
                googlebot.content = "noindex";
                document.getElementsByTagName("head")[0].appendChild(robots);
                document.getElementsByTagName("head")[0].appendChild(googlebot);
              }
            } else {
              this.notFound = true;
            }
          });
      };

      get();
    },

  },
};
</script>

<style lang="scss" scoped>
.job-page{
  background-color: #F5F5F5;
}

@include media-breakpoint-down(md) {
  dt {
    text-align: left !important;
    border: none !important;

    br {
      display: none;
    }
  }
}

/deep/li{
    list-style: disc;
}
</style>